/**
 * footballFacts.js — دادهٔ بخش «دانستنی‌های فوتبالی» (بستهٔ اول: ۵ فکت)
 * ------------------------------------------------------------------
 * هر فکت پیش از انتشار با منبع اصلی یا منبع آماری معتبر راستی‌آزمایی شده است
 * (استراتژی: ایده از FourFourTwo، آمار از Opta Analyst و MyFootballFacts،
 * رکوردهای تاریخی از RSSSF و کلمهٔ نهایی با فیفا/گینس/منبع رسمی).
 *
 * این فایل جایگزین موقت دیتابیس است؛ بعداً پنل ادمین با همین اسکیمای
 * facts-prototype.json (متن + عکس اختصاصی) جای آن را می‌گیرد و
 * ۵ فکت دیگر بستهٔ اول هم از انبار منتشر می‌شود.
 *
 * یادداشت راستی‌آزمایی هر فکت عمداً شفاف نگه داشته شده — همین شفافیت
 * اعتبار بخش «دانستنی‌های فوتبالی» را می‌سازد.
 */

export const footballFacts = [
    {
        slug: 'ali-daei-109-international-goals',
        title: 'علی دایی؛ رکوردی که نزدیک به ۱۵ سال دست‌نیافتنی ماند',
        category: 'رکورد',
        keyFigure: '۱۰۹',
        figureLabel: 'گل ملی',
        paragraphs: [
            'تا سپتامبر ۲۰۲۱، اگر از هر کارشناس آماری فوتبال می‌پرسیدید گلزن‌ترین بازیکن تاریخ فوتبال ملی کیست، پاسخ همیشه یکی بود: علی دایی. کاپیتان اسبق تیم ملی از ۱۹۹۳ تا ۲۰۰۶ در ۱۴۹ بازی ملی ۱۰۹ گل زد و به‌عنوان نخستین بازیکن تاریخ، مرز ۱۰۰ گل ملی را شکست؛ رکوردی که نزدیک به پانزده سال هیچ بازیکنی در جهان حتی به آن نزدیک نشد.',
            'نکتهٔ شیرین ماجرا اینجاست که دایی در سال ۲۰۰۳ رکورد افسانه‌ای فرِنتس پوشکاش (۸۴ گل ملی) را جابه‌جا کرد و صدمین گلش را مقابل لائوس با یک چهارگلِ کامل جشن گرفت. سرانجام کریستیانو رونالدو در سپتامبر ۲۰۲۱ با گلزنی مقابل ایرلند از این عدد عبور کرد؛ اما فکرش را ببینید: دو گلزن برتر تاریخ فوتبال، رونالدو و مسی، هر دو برای عبور از عدد دایی سال‌ها بازی کردند. این یعنی رکوردی که در برابر زمان ایستاد.',
        ],
        verifyNote: 'مبنای این متن آرشیو رسمی فیفا است: ۱۰۹ گل در ۱۴۹ بازی (۱۹۹۳ تا ۲۰۰۶). فیفا از ۲۰۲۱ در برخی اسناد رسمی، یک بازی دوستانهٔ ایران–اکوادور را در شمارش نمی‌آورد و آمار دایی را ۱۰۸ گل در ۱۴۸ بازی ثبت کرده — این تفاوتِ شمارش است، نه تعارض رکورد؛ به همین دلیل عدد نهایی پیش از هر بازنشر با صفحهٔ رسمی فیفا تطبیق داده می‌شود.',
        source: {
            name: 'FIFA.com — مصاحبهٔ رسمی صد گل دایی',
            url: 'https://www.fifa.com/en/news/articles/ali-daei-iran-interview-one-hundred-goals',
        },
        tags: ['تیم ملی', 'علی دایی', 'رکورد', 'فیفا'],
    },
    {
        slug: 'hakan-sukur-fastest-world-cup-goal',
        title: 'هاکان شوکور و سریع‌ترین گل تاریخ جام جهانی: ۱۰.۸ ثانیه',
        category: 'رکورد / عجیب',
        keyFigure: '۱۰.۸',
        figureLabel: 'ثانیه',
        paragraphs: [
            'بیست‌ونهم ژوئن ۲۰۰۲، ورزشگاه دائگو کرهٔ جنوبی، بازی رده‌بندی جام جهانی میان ترکیه و کرهٔ جنوبی. هنوز صدای سوت داور در استادیوم نچرخیده که توپ به پشت خط دروازه رسید؛ فقط ۱۰.۸ ثانیه از شروع بازی گذشته بود. هاکان شوکور، مهاجم ترکیه، با این گل سریع‌ترین گلزن تاریخ تمام ادوار جام جهانی شد؛ رکوردی که بعد از بیش از دو دهه هنوز پابرجاست.',
            'مسیر گل هم کم‌مانند بود: خطای زودهنگام در میانهٔ زمین، توپِ دوباره در اختیار ترکیه و شوت سنگین شوکور پیش از آنکه مدافعان حتی جای خود را بگیرند. ترکیه آن بازی را ۳–۲ برد و به برنز جام جهانی رسید. نکتهٔ طنز ماجرا؟ همین گلِ تاریخی، تنها گل شوکور در تاریخ جام جهانی است — یعنی با یک شلیک وارد کتاب‌های تاریخ شد.',
        ],
        verifyNote: 'تاریخ و محل بازی، نتیجهٔ ۳–۲ و ثبت رکورد به‌عنوان سریع‌ترین گل تاریخ جام جهانی در پروندهٔ رسمی فیفا تأیید شده است. فیفا در متن‌های عمومی عدد را گردشدهٔ «۱۱ ثانیه» و اسناد دقیق‌تر «۱۰.۸ ثانیه» می‌نویسند؛ اینکه این گل تنها گل شوکور در جام جهانی هم هست، در گزارش‌های بی‌بی‌سی و beIN آمده است.',
        source: {
            name: 'FIFA.com — پروندهٔ رکورد شوکور',
            url: 'https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/hakan-sukur-turkiye-fastest-goal-history',
        },
        tags: ['جام جهانی', 'ترکیه', 'شوکور', 'رکورد'],
    },
    {
        slug: 'sadio-mane-fastest-pl-hat-trick',
        title: '۲ دقیقه و ۵۶ ثانیه؛ هت‌تریک صاعقه‌آسای سادیو مانه',
        category: 'رکورد آماری',
        keyFigure: '۲:۵۶',
        figureLabel: 'هت‌تریک',
        paragraphs: [
            'شانزدهم مه ۲۰۱۵، ورزشگاه سنت‌مری ساوتهمپتون. سادیو مانه در آن بعدازظهر بهاری، دفاع آستون‌ویلا را به کابوسی شبانه تبدیل کرد: سه گل در دو دقیقه و پنجاه‌وشش ثانیه — سریع‌ترین هت‌تریک تاریخ پریمیرلیگ که رکورد قبلی رابی فاولر (۴ دقیقه و ۳۲ ثانیه در ۱۹۹۴) را تقریباً یک و نیم دقیقه جابه‌جا کرد.',
            'ساوتهمپتون آن بازی را ۶–۱ برد و مانه حتی تمام نود دقیقه را هم بازی نکرد؛ در دقیقهٔ ۷۲ تعویض شد تا کسی خسته نشود! این رکورد بعد از سال‌ها هنوز پابرجاست و رکوردنامهٔ رسمی گینس هم آن را ثبت کرده. پیام این فکت ساده است: گاهی یک بازیکن در یک بعدازظهر کاری می‌کند که ده سال آمار تحملش را ندارد.',
        ],
        verifyNote: 'زمان ۲:۵۶، تاریخ ۱۶ مه ۲۰۱۵، ورزشگاه سنت‌مری ساوتهمپتون و نتیجهٔ ۶–۱ هم در ویدئوی رسمی پریمیرلیگ و هم در صفحهٔ رکورد گینس ثبت شده است. رکورد قبلی رابی فاولر (۴:۳۲، لیورپول–آرسنال، اوت ۱۹۹۴) در گزارش‌های اسکای‌اسپورتس و آرشیو پریمیرلیگ مستند است.',
        source: {
            name: 'Guinness World Records — سریع‌ترین هت‌تریک پریمیرلیگ',
            url: 'https://www.guinnessworldrecords.com/world-records/385454-fastest-hat-trick-in-a-football-soccer-english-premier-league-match',
        },
        tags: ['پریمیرلیگ', 'ساوتهمپتون', 'مانه', 'گینس'],
    },
    {
        slug: 'rogerio-ceni-131-goals-goalkeeper',
        title: 'دروازه‌بانی که ۱۳۱ گل زد؛ راژریسنی، پنالتی‌زن افسانه‌ای سائوپائولو',
        category: 'عجیب / رکورد',
        keyFigure: '۱۳۱',
        figureLabel: 'گل',
        paragraphs: [
            'اگر کسی بگوید یک دروازه‌بان از بسیاری مهاجمان مشهور فوتبال گل بیشتری زده، شاید بخندید؛ اما راژریسنی شوخی نیست. این برزیلی بیست‌ودو سال فقط برای یک باشگاه — سائوپائولو — بازی کرد و در همین مدت ۱۳۱ گل زد: ۶۹ پنالتی، ۶۱ ضربهٔ آزاد مستقیم و تنها یک گل از جریان بازی. نه، اشتباه نخواندید؛ دروازه‌بانِ گلزن با ضربهٔ آزاد!',
            'رژینیو به‌قدری در پنالتی‌زنی تخصص داشت که داغ‌ترین لحظه‌های سائوپائولو در فینال‌ها با پای او رقم خورد؛ سه جام لیبرتادورس و قهرمانی باشگاهی جهان ۲۰۰۵ هم در کارنامه دارد. فدراسیون تاریخ و آمار فوتبال (IFFHS) او را رسماً «گلزن‌ترین دروازه‌بان تاریخ» شناخته و رکوردنامهٔ گینس هم همین رکورد را ثبت کرده. رکوردی که شاید تا صد سال دیگر کسی نزدیکش نشود.',
        ],
        verifyNote: '۱۳۱ گل (۶۹ پنالتی، ۶۱ ضربهٔ ایستگاهی، ۱ گل جریان بازی) مطابق فهرست رسمی گل‌های اوست؛ اما IFFHS شمارش ۱۲۹ گل را مبنا قرار داده و برخی آرشیوها ۱۳۲ نوشته‌اند — تعارضِ شمارشِ منابع است، نه تعارض رکورد. ازاین‌رو در متن‌های آینده از عبارت «بیش از ۱۳۰ گل» هم استفاده می‌شود تا در برابر هر دو شمارش پایدار بماند.',
        source: {
            name: 'Wikipedia — فهرست کامل گل‌های راژریسنی',
            url: 'https://en.wikipedia.org/wiki/List_of_goals_scored_by_Rog%C3%A9rio_Ceni',
        },
        tags: ['برزیل', 'سائوپائولو', 'دروازه‌بان', 'IFFHS'],
    },
    {
        slug: 'claypole-36-red-cards',
        title: '۳۶ کارت قرمز در یک بازی؛ عجیب‌ترین سوت تاریخ فوتبال',
        category: 'عجیب',
        keyFigure: '۳۶',
        figureLabel: 'کارت قرمز',
        paragraphs: [
            'بیست‌وهفتم فوریه ۲۰۱۱، لیگ دستهٔ پنجم آرژانتین، بازی کلایپوله مقابل ویکتوریانو آرناس. آنچه در این بعدازظهر معمولی گذشت، عجیب‌ترین اتفاق تاریخ داوری فوتبال بود: دامین روبینو، داور مسابقه، در پی یک درگیری دسته‌جمعی، تک‌تک بازیکنان هر دو تیم، همهٔ بازیکنان ذخیره و حتی مربیان را اخراج کرد. جمعاً ۳۶ کارت قرمز!',
            'رکوردنامهٔ گینس این بازی را رسماً «بیشترین اخراج در یک مسابقهٔ فوتبال» ثبت کرده است. عکس‌های آن روز نشان می‌دهد داوری که عملاً با یک دسته‌کارت قرمز به وسط زمین آمده بود! روبینو یک‌شبه معروف شد؛ مصاحبه‌های جهانی گرفت و نامش برای همیشه در تاریخ عجیب‌های فوتبال حک شد. این فکت هم نمونهٔ خوبی است که چرا هر «رکورد» را باید با سند اصلی چک کرد.',
        ],
        verifyNote: 'تاریخ ۲۷ فوریه ۲۰۱۱، لیگ پری‌مرا D آرژانتین و عدد ۳۶ در صفحهٔ رسمی رکوردهای گینس («بیشترین کارت قرمز در یک مسابقهٔ فوتبال») مستند است؛ گزارش‌های بی‌بی‌سی و ایندیپندنت هم اخراج «همهٔ بازیکنان، ذخیره‌ها و مربیان» را تأیید می‌کنند.',
        source: {
            name: 'Guinness World Records — بیشترین کارت قرمز یک بازی',
            url: 'https://www.guinnessworldrecords.com/world-records/64281-most-red-cards-in-a-football-match',
        },
        tags: ['آرژانتین', 'داوری', 'گینس', 'عجیب'],
    },
]
